const getOC = () =>
  navigator.userAgent?.match(/\((.*?)\)/)?.[0].slice(1, -1) as string;
export default getOC;
